export const strings = {
  NAME: "Chatbot",

  DESCRIPTION: "Build an AI-powered chatbot.",
} as const;
